import styled from '@emotion/styled'
import * as v from '../../variables/styled'

export const SideMenuContainer = styled.div(props => ({
  display: 'none',

  '@media only screen and (min-width: 600px)': {
    /* For Tablet: */
    display: 'none'
  },

  '@media only screen and (min-width: 769px)': {
    /* For Desktop: */
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    background: '#FFF',
    transition: 'width 0.3s',
    width: v.menuWidth(props.showMenu, props.collapseMenu),
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 6px 0px',
    zIndex:1,
    fontSize: '1em',

    nav: {
      height: '100%',
    },
  
    'nav a.active > div':{
      background:'rgb(245, 246, 250) !important',
      borderRadius:'10px 0px 0px 10px',
      color: 'rgb(251, 191, 102) !important'
    },
  
    'nav a.active > div > div':{
      color: 'rgb(251, 191, 102) !important',
      '.MuiTypography-body1':{
        fontWeight:'bold'
      }
    },
  
    '.subMenu': {
      paddingLeft: '40px'
    },
  
    '.MuiListItemIcon-root': {
      minWidth: 0,
      marginRight: '15px',
      color:'#505050'
    },
  
    '.MuiListItemText-inset': {
      paddingLeft: 0,
    },
  
    '.MuiListItemText-root':{
      color:'#505050',
      '.MuiTypography-body1':{
        fontFamily: 'IBM Plex Sans Thai',
        fontSize:'1rem'
      }
    },
  
    '.MuiTypography-body1': {
      fontSize: '0.9rem',
    }
  },
}))

export const SubMenuContainer = styled.div(props => ({
  paddingLeft: '10px'
}))

export const FabContainer = styled.div(props => ({
  display: 'flex',
  position: 'fixed',
  bottom: '10px',
  left: props.collapseMenu ? '40px' : '180px',
  transition: 'left 0.3s',
  justifyContent: 'center',
}))